import { render, staticRenderFns } from "./fxyp.vue?vue&type=template&id=061e470b&scoped=true"
import script from "./fxyp.vue?vue&type=script&lang=js"
export * from "./fxyp.vue?vue&type=script&lang=js"
import style0 from "./fxyp.vue?vue&type=style&index=0&id=061e470b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e470b",
  null
  
)

export default component.exports